import api from "@services/api-service";

export default {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////
  state: {},

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////
  mutations: {},

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////
  getters: {
    fetchPorcentagemDesconto: () => () => new Promise((resolve, reject) => {
      api().get(`percentuais`).then(response => {
        if (response.data.status) {
          resolve(response.data.data);
        }

        reject(response);
      })
    })
  },

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////
  actions: {}
};
